// Autogenerated file
export const logistTaskTypesEnum = {
    NotificationType: "NotificationType",
    NeedBidForServiceWork: "NeedBidForServiceWork",
    ApprovingServiceWorkInBid: "ApprovingServiceWorkInBid",
    ApprovingServiceWorkInEmptyMileageBid: "ApprovingServiceWorkInEmptyMileageBid",
    NeedDriverShift: "NeedDriverShift",
};
export const logistTaskTypes = [
    { label: "Уведомление по заявке", value: "NotificationType" },
    { label: "Отправить машину для прохождения сервисной работы", value: "NeedBidForServiceWork" },
    { label: "Согласовать заезд в СТО в рамках логистической заявки", value: "ApprovingServiceWorkInBid" },
    { label: "Согласовать заезд в СТО в рамках порожней заявки", value: "ApprovingServiceWorkInEmptyMileageBid" },
    { label: "Отправить машину для пересменки", value: "NeedDriverShift" },
];
